import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getAgentEvaluationsData, getSavedEvaluationFormData, getTrainerTableData, saveEvaluationData, updateAgentTrainingCommentsDataStart } from '../../actions/Applications/aquaa.action';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { AssignedAccountsTblPopUp } from '../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels';
import Edit_Icon from './../../assets/onboard-images/Edit_Icon.png';
import { DateFormatter } from '../../components/ReusableComponents/DateFormatter';

const AquaaAgentsEvaluations = () => {
     const dispatch = useDispatch();
      const history = useHistory();
      const [isEvaluationFetched, setIsEvaluationFetched] = useState(false);
      const[completeModel,setCompleteModel] = useState(false);
      const [selectedRow, setSelectedRow] = useState(null);
      const [selectedComment, setSelectedComment] = useState('');
      const [commentError, setCommentError] = useState("");
    
      const agentEvaluationsData = useSelector((state) => state.aquaaReducer.agentEvaluationsData);
      const savedevaluationFormData = useSelector((state) => state.aquaaReducer.savedevaluationFormData);
      const trainerTableData = useSelector((state) => state.aquaaReducer.trainerTableData);
console.log('trainerTableData',trainerTableData)
    
      // Fetch the saved evaluations data on component mount
      useEffect(() => {
        dispatch(getAgentEvaluationsData());
        dispatch(getTrainerTableData())
      }, [dispatch]);
    
      // Get columns based on saved evaluations data
      const columns = agentEvaluationsData && agentEvaluationsData.length > 0 ? Object.keys(agentEvaluationsData[0]) : [];
      const trainerColumns =
  trainerTableData && trainerTableData.length > 0
    ? Object.keys(trainerTableData[0])
    : [];

      const[saveEvaluationID,setSaveEvaluationID] = useState()
      // Handler for clicking on a contact ID
      const contactIdHandler = (row) => {
        if (row.evaluationID ) {
dispatch({ type: 'SAVED_EVALUATION_FORM_DATA', payload: [] });
    setIsEvaluationFetched(true);
    setSaveEvaluationID(row.evaluationID);
    dispatch(getSavedEvaluationFormData(row.evaluationID)); // Then fetch new one
         
        }
      };
    
      // useEffect to navigate after the form data is successfully fetched and stored
      useEffect(() => {
        if (
          savedevaluationFormData &&
          Array.isArray(savedevaluationFormData) &&
          savedevaluationFormData.length > 0 && isEvaluationFetched 
        ) {
          // Save the evaluation data to the store (if needed)
          dispatch(saveEvaluationData([...savedevaluationFormData]));
    
          setIsEvaluationFetched(false)
    
          history.push('/evaluationform');
        
    
        }
      }, [savedevaluationFormData,dispatch,history,isEvaluationFetched,saveEvaluationID]);

      const submitHandler = () => {
           if (!selectedRow) return;
           if (!selectedComment || selectedComment.trim() === "") {
    setCommentError("Comments are required");
    return; 
  }

  setCommentError("");
        dispatch(updateAgentTrainingCommentsDataStart(
          [{"EvaluationsID":selectedRow.evaluationsID,
            "Recommendation":selectedRow.recommendation,
            "AgentComments":selectedComment}]
          ,() => {
                dispatch(getTrainerTableData());
              }));
        setCompleteModel(false)
      }

      console.log('savedevaluationFormData',savedevaluationFormData)
  return (
    <section>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={false}
            label3='AQuAA Agent Evaluations' />
      <section className="App_Layout" style={{ marginBottom: '20px' }}>
        <div className="Applications_Title"> AQuAA Agent Evaluations </div>
      </section>
      <div className="aquaa-table-container">
        <table className="aquaa-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {agentEvaluationsData && agentEvaluationsData.length > 0 ? (
                agentEvaluationsData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => {
                    const cellData = row[col]; // Get the data for this column in the current row

                    if (col === 'evaluationDate') {
                      return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                    }

                    return (
                      <td key={colIndex} style={col === 'evaluationID' ? { cursor: 'pointer', color: '#004aac' } : null}>
                        {col === 'evaluationID' ? <div onClick={() => { contactIdHandler(row) }}>{cellData}</div> : (cellData)}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  <section>
                    <div className="noData-para" style={{ marginTop: 0 }}>
                      <div style={{ marginTop: 30 }}>
                        No data available, please try different filters or contact the admin.
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <section className="App_Layout" style={{ marginBottom: '20px' }}>
  <div className="Applications_Title"> Agent Trainings </div>
</section>

<div className="aquaa-table-container">
  <table className="aquaa-table">
    <thead>
      <tr>
        {trainerColumns.map((col, index) => (
          <th key={index}>{col}</th>
        ))}
      </tr>
    </thead>

    <tbody>
      {trainerTableData && trainerTableData.length > 0 ? (
        trainerTableData.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {trainerColumns.map((col, colIndex) => {
              const value = row[col];

              if (col === "action Due Date" || col === "action Date" || col === "acknowledged Date") {
                return (
                  <td key={colIndex}>
                    {value ? DateFormatter(value) : "-"}
                  </td>
                );
              }

              return (
                <td
                  key={colIndex}
                  style={
                    col === "evaluationsID"
                      ? { cursor: "pointer", color: "#004aac" }
                      : null
                  }
                >
                  {col === "evaluationsID" ? (
                    <div onClick={() => contactIdHandler({ evaluationID: value })}>
                      {value}
                    </div>
                  ) : (
                    value || "-"
                  )}
                </td>
              );
            })}
            <td>
  {!row["acknowledged Date"] && (
    <img
      src={Edit_Icon}
      alt=""
      onClick={() => {
        setSelectedRow(row);
        setCompleteModel(true);
      }}
      style={{ cursor: "pointer" }}
    />
  )}
</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={trainerColumns.length}>
            <section>
              <div className="noData-para" style={{ marginTop: 0 }}>
                <div style={{ marginTop: 30 }}>
                  No data available.
                </div>
              </div>
            </section>
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

  {completeModel && (
                <AssignedAccountsTblPopUp isOpen={completeModel} setShowModal={setCompleteModel}>
                <div className='Applications_Title' style={{fontSize:'20px', marginBottom:20}}>Comments</div>
                  <div >
                    <textarea 
                      type="text"
                      placeholder="Comments"
                      value={selectedComment}
                      onChange={(e) =>{setSelectedComment(e.target.value);
                      if (e.target.value.trim() !== "") {
      setCommentError(""); // clear error while typing
    }}}
                      style={{
              width: '100%',
              height: '100px',
              padding: '10px',
              fontSize: '14px',
              resize: 'vertical',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box'
            }}
                    />
                    {commentError && (
  <div style={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>
    {commentError}
  </div>
)}
                  </div>
                  <main style={{ display: 'flex', justifyContent: 'center' }}>   <div className='btn_adduser' onClick={() => submitHandler()}>Submit</div>
                    <div className='btn_canceluser' onClick={() => {setCompleteModel(false);setSelectedComment('')}}>Cancel</div></main>
                </AssignedAccountsTblPopUp>
              )}
    </section>
  )
}

export default AquaaAgentsEvaluations